import {useMemo} from "react";
import {startOfToday} from "date-fns";

import {AdditionalAreaIcon, AreaIcon, CalendarCheckIcon, FloorsIcon, FloorUpIcon, KitchenIcon, RoomsIcon, WorldSideIcon} from "@pg-design/icons-module";
import {areaFormat, formatPL} from "@pg-mono/string-utils";

import {PropertyCardDetailInfoTableRowKey} from "../constants/property_card_detail_info_table_content";
import {IVariable} from "../types/IVariable";
import {IPropertyDetailDTO} from "../types/property/IPropertyDetailDTO";
import {getKitchenTypeName} from "../types/property/KitchenType";
import {getRoomsPlural} from "../utils/get_rooms_plural";
import {
    getPropertyCardDetailAdditionalAreasValue,
    getPropertyCardDetailConstructionDate,
    getPropertyCardDetailFloorValue,
    getPropertyCardDetailQuarterLabels,
    PROPERTY_CARD_DETAIL_INFO_TABLE_ICON_PROPS
} from "../utils/property_card_detail_info_table_utils";

import * as styles from "./use_homematch_property_card_detail_info_table_data.module.css";

export interface IHomematchPropertyCardDetailInfoTableRow {
    icon: React.ReactNode;
    value: number | string | undefined;
}

type InfoTableIconComponent = typeof RoomsIcon;

export const useHomematchPropertyCardDetailInfoTableData = (
    property: IPropertyDetailDTO,
    quarterTypes: IVariable[] = []
): Record<PropertyCardDetailInfoTableRowKey, IHomematchPropertyCardDetailInfoTableRow> => {
    const today = useMemo(() => formatPL(startOfToday(), "yyyy-MM-dd"), []);

    const additionalAreasValue = getPropertyCardDetailAdditionalAreasValue(property.additional_areas);
    const constructionDate = getPropertyCardDetailConstructionDate(property.built_date, today);
    const floorValue = getPropertyCardDetailFloorValue(property.floor);
    const kitchenValue = getKitchenTypeName(property.kitchen_type) || undefined;
    const quarterLabels = getPropertyCardDetailQuarterLabels(property.quarters, quarterTypes);
    const roomsValue = `${property.rooms} ${getRoomsPlural(property.rooms)}`;

    const renderInfoTableIcon = (Icon: InfoTableIconComponent) => <Icon {...PROPERTY_CARD_DETAIL_INFO_TABLE_ICON_PROPS} className={styles.inlineIcon} />;

    return {
        additional_areas: {
            icon: renderInfoTableIcon(AdditionalAreaIcon),
            value: additionalAreasValue
        },
        area: {
            icon: renderInfoTableIcon(AreaIcon),
            value: areaFormat(property.area)
        },
        construction_end_date: {
            icon: renderInfoTableIcon(CalendarCheckIcon),
            value: constructionDate
        },
        floor: {
            icon: renderInfoTableIcon(FloorUpIcon),
            value: floorValue
        },
        floors: {
            icon: renderInfoTableIcon(FloorsIcon),
            value: property.floors
        },
        kitchen: {
            icon: renderInfoTableIcon(KitchenIcon),
            value: kitchenValue
        },
        quarters: {
            icon: renderInfoTableIcon(WorldSideIcon),
            value: quarterLabels
        },
        rooms: {
            icon: renderInfoTableIcon(RoomsIcon),
            value: roomsValue
        }
    };
};
import {useMemo} from "react";
import {startOfToday} from "date-fns";

import {AdditionalAreaIcon, AreaIcon, CalendarCheckIcon, FloorsIcon, FloorUpIcon, KitchenIcon, RoomsIcon, WorldSideIcon} from "@pg-design/icons-module";
import {areaFormat, formatPL} from "@pg-mono/string-utils";

import {PropertyCardDetailInfoTableRowKey} from "../constants/property_card_detail_info_table_content";
import {IVariable} from "../types/IVariable";
import {IPropertyDetailDTO} from "../types/property/IPropertyDetailDTO";
import {getKitchenTypeName} from "../types/property/KitchenType";
import {getRoomsPlural} from "../utils/get_rooms_plural";
import {
    getPropertyCardDetailAdditionalAreasValue,
    getPropertyCardDetailConstructionDate,
    getPropertyCardDetailFloorValue,
    getPropertyCardDetailQuarterLabels,
    PROPERTY_CARD_DETAIL_INFO_TABLE_ICON_PROPS
} from "../utils/property_card_detail_info_table_utils";

import * as styles from "./use_homematch_property_card_detail_info_table_data.module.css";

export interface IHomematchPropertyCardDetailInfoTableRow {
    icon: React.ReactNode;
    value: number | string | undefined;
}

type InfoTableIconComponent = typeof RoomsIcon;

export const useHomematchPropertyCardDetailInfoTableData = (
    property: IPropertyDetailDTO,
    quarterTypes: IVariable[] = []
): Record<PropertyCardDetailInfoTableRowKey, IHomematchPropertyCardDetailInfoTableRow> => {
    const today = useMemo(() => formatPL(startOfToday(), "yyyy-MM-dd"), []);

    const additionalAreasValue = getPropertyCardDetailAdditionalAreasValue(property.additional_areas);
    const constructionDate = getPropertyCardDetailConstructionDate(property.built_date, today);
    const floorValue = getPropertyCardDetailFloorValue(property.floor);
    const kitchenValue = getKitchenTypeName(property.kitchen_type) || undefined;
    const quarterLabels = getPropertyCardDetailQuarterLabels(property.quarters, quarterTypes);
    const roomsValue = `${property.rooms} ${getRoomsPlural(property.rooms)}`;

    const renderInfoTableIcon = (Icon: InfoTableIconComponent) => <Icon {...PROPERTY_CARD_DETAIL_INFO_TABLE_ICON_PROPS} className={styles.inlineIcon} />;

    return {
        additional_areas: {
            icon: renderInfoTableIcon(AdditionalAreaIcon),
            value: additionalAreasValue
        },
        area: {
            icon: renderInfoTableIcon(AreaIcon),
            value: areaFormat(property.area)
        },
        construction_end_date: {
            icon: renderInfoTableIcon(CalendarCheckIcon),
            value: constructionDate
        },
        floor: {
            icon: renderInfoTableIcon(FloorUpIcon),
            value: floorValue
        },
        floors: {
            icon: renderInfoTableIcon(FloorsIcon),
            value: property.floors
        },
        kitchen: {
            icon: renderInfoTableIcon(KitchenIcon),
            value: kitchenValue
        },
        quarters: {
            icon: renderInfoTableIcon(WorldSideIcon),
            value: quarterLabels
        },
        rooms: {
            icon: renderInfoTableIcon(RoomsIcon),
            value: roomsValue
        }
    };
};
